export default __webpack_public_path__ + "static/placeholder--article-d116f2c562871867a705d7915a49dfe3.jpg";